import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExpandLess = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgExpandLess" data-sentry-source-file="expand-less.tsx">
    <g clipPath="url(#expand-less_svg__a)" data-sentry-element="g" data-sentry-source-file="expand-less.tsx">
      <path fill="#263E6A" d="m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" data-sentry-element="path" data-sentry-source-file="expand-less.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="expand-less.tsx">
      <clipPath id="expand-less_svg__a" data-sentry-element="clipPath" data-sentry-source-file="expand-less.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="expand-less.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgExpandLess;